import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const AssetDisposal = () => {
  return <ErpTablePage moduleKey="asset_disposal" />;
};

export default AssetDisposal;